import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuracoes } from '../models/configuracoes.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SistemaService {
  public static readonly MENSAGEM_PADRAO_MANUTENCAO = 'Sistema em manutenção';

  private emManutencaoSubject = new BehaviorSubject<boolean>(false);
  emManutencao$ = this.emManutencaoSubject.asObservable();

  private showManutencaoMessageSubject = new BehaviorSubject<boolean>(false);
  showManutencaoMessage$ = this.showManutencaoMessageSubject.asObservable();

  private isLoadingSubject = new BehaviorSubject<boolean>(true);
  isLoading$ = this.isLoadingSubject.asObservable();

  private manutencaoMessageSubject = new BehaviorSubject<string>(
    SistemaService.MENSAGEM_PADRAO_MANUTENCAO
  );
  manutencaoMessage$ = this.manutencaoMessageSubject.asObservable();

  private isAcessoInternoSubject = new BehaviorSubject<boolean>(false);
  isAcessoInterno$ = this.isAcessoInternoSubject.asObservable();

  constructor(private http: HttpClient) { }

  /**
   * Ativa o modo de manutenção, exibindo uma mensagem personalizada.
   * @param mensagem Mensagem a ser exibida durante o modo de manutenção.
   */
  ativarModoManutencao(mensagem: string): void {
    this.ativarMensagemManutencaoFutura(mensagem);
    this.emManutencaoSubject.next(true);
  }

  /**
   * Ativa a mensagem de manutenção futura, exibindo uma mensagem personalizada.
   * @param mensagem Mensagem a ser exibida sobre a manutenção futura.
   */
  ativarMensagemManutencaoFutura(mensagem: string) {
    this.manutencaoMessageSubject.next(mensagem);
    this.showManutencaoMessageSubject.next(true);
  }

  /**
   * Esconde apenas a mensagem de manutenção, sem desativar o modo de manutenção.
   */
  esconderMensagemManutencao() {
    this.showManutencaoMessageSubject.next(false);
  }

  /**
   * Busca as configurações do sistema.
   * @returns Observable com as configurações do sistema.
   */
  getConfiguracoes() {
    const url = `/api/sistema/config`;

    this.http.get<Configuracoes>(url).subscribe({
      next: (configuracoes) => {
        if (configuracoes.emManutencao) {
          this.ativarModoManutencao(configuracoes.mensagemManutencao);
        } else {
          if (configuracoes.ativarMensagemManutencao) {
            this.ativarMensagemManutencaoFutura(
              configuracoes.mensagemManutencao
            );
          }
        }
        this.isAcessoInternoSubject.next(configuracoes.internalIp);
        this.isLoadingSubject.next(false);
      },
      error: (erro) => {
        this.isLoadingSubject.next(false);
        console.error(
          'Não foi possível carregar as configurações do sistema, tente novamente mais tarde'
        );
      },
    });

    return;
  }
}
